export default __webpack_public_path__ + "static/media/greenleaf_horizontal.78d3492f.png";